import React, { useEffect, useRef, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumbs from '../components/Breadcrumbs';
import TopFilter from '../components/TopFilter';
import RightFilterToggle from '../components/RightFilterToggle';
import paginationFactory from 'react-bootstrap-table2-paginator';
import GridData from '../components/gridmodal/GridDataPackages';
// import { propTypes } from 'react-bootstrap/esm/Image';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.css';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
// import PriceFilter from '../components/CustomGridFilter';
import configData from '../configData.json';
import { format } from 'date-fns';
import Spinner from 'react-bootstrap/Spinner';
import ColumnFilter from '../components/ColumnFilter';
import { Link } from 'react-router-dom';
import LeftMenu from '../components/LeftMenu';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';
import GridDataPackages from '../components/gridmodal/GridDataPackages';
import F68RightFilterToggle from '../components/F68RightFilterToggle';
import TopFilterManuallyTouchedBills from '../components/TopFilterManullyTouchedBills';
import GridDataManuallyTouchedBills from '../components/gridmodal/GridDataManuallTouchedBills';
import MycustomDesignGrid from '../components/MycustomDesignGrid';
import SweetAlert from "react-bootstrap-sweetalert";
import { ValidDate, formatNumnberWithComma, formatAmountWithComma, formatDate, removeCommafromNumber } from '../components/Utlities';


const freightBillFormattercsv = (cell, row, rowIndex, formatExtraData) => {
    return (
        "=" + '"' + cell + '"'
    )
}


const invoicenumberFormattercsv = (cell, row, rowIndex, formatExtraData) => {
    return (
        "=" + '"' + cell + '"'
    )
}


const accountnumberFormattercsv = (cell, row, rowIndex, formatExtraData) => {
    return (
        "=" + '"' + cell + '"'
    )
}
const entryDateFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
        <span>{format(new Date(cell), "MM/dd/yyyy")}</span>
    )
}

const entryDateFormattercsv = (cell, row, rowIndex, formatExtraData) => {
    let newDate = format(new Date(cell), "MM/dd/yyyy");
    return (
        "=SUBSTITUTE(" + '"' + newDate + '"' + "," + '"' + "-" + '"' + "," + '"' + "/" + '"' + ")"
    )
}


const invoiceDateFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
        <span>{format(new Date(cell), "MM/dd/yyyy")}</span>
    )
}

const invoiceDateFormattercsv = (cell, row, rowIndex, formatExtraData) => {
    let newDate = format(new Date(cell), "MM/dd/yyyy");
    return (
        "=SUBSTITUTE(" + '"' + newDate + '"' + "," + '"' + "-" + '"' + "," + '"' + "/" + '"' + ")"
    )
}

const imageLinkFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
        <a target="_blank" href={cell}>View</a>
    )
}

const imageLinkFormattercsv = (cell, row, rowIndex, formatExtraData) => {
    return (
        "=HYPERLINK(" + '"' + cell + '",' + '"' + "View" + '"' + ")"
    )
}


export default function ManuallyTouchedBills() {

    const [manuallyTouchedBills, setManuallyTouchedBills] = useState([]);
    const [detailManuallyTouchedBills, setDetailData] = useState([]);
    const [selectedSummaryRow, setSelectedRow] = useState({});
    const [lastElement, setLastElement] = useState(null);
    const [hidden, setHidden] = useState(true);
    const [hiddenExcel, setHiddenExcel] = useState(true);
    const [fbNum, setFbNum] = useState("");
    const [acctNo, setAcctNo] = useState("");

    const { ExportCSVButton } = CSVExport;
    const { ExportCSVButtonDetail } = CSVExport;

    const [fromDate, setFromDate] = useState(undefined);
    const [toDate, setToDate] = useState(undefined);
    const [fromShipDate, setFromShipDate] = useState(undefined);
    const [toShipDate, setToShipDate] = useState(undefined);
    const [loading, setLoading] = useState(false);

    const [fromtoDate, setFromtoDate] = useState('Entered Date between:');

    const [page, setPage] = useState(1);
    const [fbLoading, setFBLoading] = useState(false);
    const [prevY, setPrevY] = useState(0);

    const [selectedOption, setSelectedOption] = useState('defaultExcel');

    const [newErrorAlert, setNewErrorAlert] = useState(true);
    const [newSuccessAlert, setNewSuccessAlert] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const onConfirmFunc = () => {
        setNewErrorAlert(true);
        setNewSuccessAlert(true);
        setErrorMessage("");
    };
    const [detailLevel, setDetailLevel] = useState('Division');
    const [isHidden, setIsHidden] = useState(false);

    let prevYRef = useRef({});
    let selectedRowRef = useRef({});
    let detailManuallyTouchedRef = useRef({});
    let hiddenRef = useRef({});
    let pageRef = useRef({});

    prevYRef.current = prevY;
    selectedRowRef.current = selectedSummaryRow;
    detailManuallyTouchedRef.current = detailManuallyTouchedBills;
    hiddenRef.current = hidden;
    pageRef.current = page;

    let ManuallTouchedBillRef = useRef({});
    ManuallTouchedBillRef.current = manuallyTouchedBills;


    const [ownerName, setOwnerName] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [customerShortName, setCustomerShortName] = useState('');
    const [divisionName, setDivisionName] = useState('');
    const [regionName, setRegionName] = useState('');
    const [branchName, setBranchName] = useState('');

    const [selectedCustKey, setSelectedCustKey] = useState(0);
    const [selectedDivisionKey, setSelectedDivisionKey] = useState(0);
    const [selectedRegionKey, setSelectedRegionKey] = useState(0);
    const [selectedBranchKey, setSelectedBranchKey] = useState(0);
    const [selectedReportName, setSelectedReportName] = useState('');
    const [selectedExcludeRateAndRouteAnalysis, setSelectedExcludeRateAndRouteAnalysis] = useState('N');

    const [summaryFileName, setSummaryFileName] = useState('');
    const [detailsFileName, setDetailsFileName] = useState('');

    const [sumExportLoading, setSumExportLoading] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);


    const criData = [
        { criKey: 1, criValue: 'Owner' },
        { criKey: 2, criValue: 'Customer' },
        { criKey: 3, criValue: 'Division' },
        { criKey: 4, criValue: 'Region' },
        { criKey: 5, criValue: 'Branch' },
        { criKey: 6, criValue: 'Exclude Rate and Route Analysis' }
    ];

    const [toExportDate, setExportToDate] = useState('');

    const [columnsDetail, setColumnsDetail] = useState([
        {
            dataField: 'carrierName',
            text: 'Transportation Provider Name',
            headerStyle: { width: '200px', textAlign: 'center' },
            align: 'left',
            sort: true,
            csvFormatter: freightBillFormattercsv,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'proNumber',
            text: 'Freight Bill/Package Number',
            headerStyle: { width: '120px', textAlign: 'center' },
            align: 'left',
            sort: true,
            csvFormatter: invoicenumberFormattercsv,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'invoiceNumber',
            text: 'Invoice Number',
            headerStyle: { width: '85px', textAlign: 'center' },
            align: 'left',
            sort: true,
            csvFormatter: accountnumberFormattercsv,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'billedAmount',
            text: 'Billed Amount',
            headerStyle: { width: '152px', textAlign: 'center' },
            align: 'right',
            sort: true,
            // formatter: AmountFormatter,
            // csvFormatter: AmountFormatterCsv,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'paidAmount',
            text: 'Paid Amount',
            headerStyle: { width: '92px', textAlign: 'center' },
            align: 'right',
            sort: true,
            // formatter: AmountFormatter,
            // csvFormatter: AmountFormatterCsv,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'freightBillKey',
            text: 'Freight Bill Key',
            headerStyle: { width: '150px', textAlign: 'center' },
            align: 'left',
            sort: true,
            csvFormatter: freightBillFormattercsv,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        }
    ])





    const searchOnClick = (customerKey, divisonKey, regionKey, branchKey, startDate, endDate, startShipDate, endShipDate, reportName, excludeRateAndRouteAnalysis) => {
        debugger;
        let endDateMonth = endDate.toString().substring(5, 7);
        let endDateDay = endDate.toString().substring(8, 10);
        let endDateYear = endDate.toString().substring(0, 4);
        // setFromtoDate('Entered Date between: '  + startDateMonth + '/' + startDateDay + '/' + startateYear + ' and ' + endDateMonth + '/' + endDateDay + '/' + endDateYear);
        setExportToDate(endDateMonth + endDateDay + endDateYear);
        setSelectedCustKey(customerKey);
        setSelectedDivisionKey(divisonKey);
        setSelectedRegionKey(regionKey);
        setSelectedBranchKey(branchKey);
        setFromDate(startDate);
        setToDate(endDate);
        setFromShipDate(startShipDate);
        setToShipDate(endShipDate);
        setSelectedReportName(reportName);
        setSelectedExcludeRateAndRouteAnalysis(excludeRateAndRouteAnalysis);

        LoadSummaryData(customerKey, divisonKey, regionKey, branchKey, startDate, endDate, startShipDate, endShipDate, reportName, excludeRateAndRouteAnalysis);



    }

    const GenerateFileNameConvention = (customerSshortName, divisonKey, divisionSname, regionKey, regionSname, branchKey, branchSname, endSDate) => {
        // File Generation
        debugger;
        let divisionValues = divisonKey.split(',');
        let regionValues = regionKey.split(',');
        let branchValues = branchKey.split(',');

        let endDateMonth = endSDate.toString().substring(5, 7);
        let endDateDay = endSDate.toString().substring(8, 10);
        let endDateYear = endSDate.toString().substring(2, 4);

        let dateString = endDateMonth + endDateDay + endDateYear;

        // CATEGORY 1 and CATEGORY 2
        debugger;
        if (divisionValues[0] == -1 && regionValues[0] == -1 && branchValues[0] == -1) {
            setDetailLevel('Division');
            setIsHidden(false);
            setSummaryFileName('F068_' + customerSshortName + '_' + dateString);
            setDetailsFileName('F068_' + customerSshortName + '_' + dateString + '_ALL');
        }
        // CATEGORY 3
        else if ((divisionValues.length == 1 && divisionValues[0] != -1)
            && regionValues[0] == -1 && branchValues[0] == -1) {
            setIsHidden(true);
            setSummaryFileName('F068_' + customerSshortName + '_' + divisionSname + '_' + dateString);
        }
        // CATEGORY 4 and CATEGORY 5
        else if (divisionValues.length > 1 && regionValues[0] == -1 && branchValues[0] == -1) {
            setDetailLevel('Division');
            setIsHidden(false);
            setSummaryFileName('F068_' + customerSshortName + '_MULTIPLEDIVISIONS_' + dateString);
            setDetailsFileName('F068_' + customerSshortName + '_MULTIPLEDIVISIONS_' + dateString + '_ALL');
        }
        // CATEGORY 6
        else if ((divisionValues.length == 1 && divisionValues[0] != -1)
            && (regionValues.length == 1 && regionValues[0] != -1)
            && branchValues[0] == -1) {
            setIsHidden(true);
            setSummaryFileName('F068_' + customerSshortName + '_' + regionSname + '_' + dateString);
        }
        // CATEGORY 7 && CATEGORY 8
        else if ((divisionValues.length >= 1 && divisionValues[0] != -1)
            && regionValues.length > 1
            && branchValues[0] == -1) {
            setDetailData('Region');
            setIsHidden(false);
            setSummaryFileName('F068_' + customerSshortName + '_MULTIPLEREGIONS_' + dateString);
            setDetailsFileName('F068_' + customerSshortName + '_MULTIPLEREGIONS_' + dateString + '_ALL');
        }
        // CATEGORY 9
        else if ((divisionValues.length == 1 && divisionValues[0] != -1)
            && (regionValues.length == 1 && regionValues[0] != -1)
            && (branchValues.length == 1 && branchValues[0] != -1)) {
            setIsHidden(true);
            setSummaryFileName('F068_' + customerSshortName + '_' + branchSname + '_' + dateString);
        }
        // CATEGORY 10 and CATEGORY 11
        else if (divisionValues[0] != -1 && regionValues[0] != -1 && branchValues.length > 1) {
            setDetailData('Branch');
            setIsHidden(false);
            setSummaryFileName('F068_' + customerSshortName + '_MULTIPLEBRANCHES_' + dateString);
            setDetailsFileName('F068_' + customerSshortName + '_MULTIPLEBRANCHES_' + dateString + '_ALL');
        }
    }

    const LoadSummaryData = async (customerKey, divisonKey, regionKey, branchKey, startDate, endDate, startShipDate, endShipDate, reportName, excludeRateAndRouteAnalysis) => {
        debugger;
        setLoading(true);
        const URL = `${configData.BASE_APP_URL}FreightBill/GetF068Summary/${customerKey}/${divisonKey}/${regionKey}/${branchKey}/${startDate}/${endDate}/${startShipDate}/${endShipDate}/${reportName}/${excludeRateAndRouteAnalysis}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => setManuallyTouchedBills(resp))

        setLoading(false);

        let startDateMonth = startDate.toString().substring(5, 7);
        let startDateDay = startDate.toString().substring(8, 10);
        let startateYear = startDate.toString().substring(0, 4);
        let endDateMonth = endDate.toString().substring(5, 7);
        let endDateDay = endDate.toString().substring(8, 10);
        let endDateYear = endDate.toString().substring(0, 4);
        if (ManuallTouchedBillRef.current.length > 0) {
            setFromtoDate('Entered Date between: ' + startDateMonth + '/' + startDateDay + '/' + startateYear + ' and ' + endDateMonth + '/' + endDateDay + '/' + endDateYear);
            setOwnerName(ManuallTouchedBillRef.current[0].ownerName);
            setCustomerName(ManuallTouchedBillRef.current[0].customerName);
            setDivisionName(ManuallTouchedBillRef.current[0].divisionName);
            setRegionName(ManuallTouchedBillRef.current[0].regionName);
            setBranchName(ManuallTouchedBillRef.current[0].branchName);
            setCustomerShortName(ManuallTouchedBillRef.current[0].customerShortName)

            setExportToDate(endDateMonth + endDateDay + endDateYear);
            setSelectedCustKey(customerKey);
            setSelectedDivisionKey(divisonKey);
            setSelectedRegionKey(regionKey);
            setSelectedBranchKey(branchKey);
            setFromDate(startDate);
            setToDate(endDate);
            setFromShipDate(startShipDate);
            setToShipDate(endShipDate);
            setSelectedReportName(reportName);
            setSelectedExcludeRateAndRouteAnalysis(excludeRateAndRouteAnalysis);

            GenerateFileNameConvention(ManuallTouchedBillRef.current[0].customerShortName, divisonKey, ManuallTouchedBillRef.current[0].divisionName,
                regionKey, ManuallTouchedBillRef.current[0].regionName,
                branchKey, ManuallTouchedBillRef.current[0].branchName,
                endDate);
        }
        else {
            setFromtoDate('Entered Date between:');
            setOwnerName('');
            setCustomerName('');
            setDivisionName('');
            setRegionName('');
            setBranchName('');
        }

    }

    const SelectDownloadOptions = async () => {
        debugger;
        if (selectedOption === 'defaultExcel') {
            // download summary data
            DownloadExcelData();
        } else if (selectedOption === 'detailExcel') {
            // download summary with details tab data
            LogEmailData(selectedCustKey, selectedDivisionKey, selectedRegionKey, selectedBranchKey, fromDate, toDate, fromShipDate, toShipDate, selectedExcludeRateAndRouteAnalysis)
        }
    }

    const LogEmailData = async (customerKey, divisonKey, regionKey, branchKey, startDate, endDate, startShipDate, endShipDate, excludeRateAndRouteAnalysis) => {
        // setLoading(true);
        debugger;
        let email = sessionStorage.getItem('my-emailid');
        let fileName = 'F068_' + customerShortName + '_' + toExportDate + '.xlsx';
        const URL = `${configData.BASE_APP_URL}FreightBill/LogEmailRequest/${email}/${customerKey}/${divisonKey}/${regionKey}/${branchKey}/${startDate}/${endDate}/${startShipDate}/${endShipDate}/${excludeRateAndRouteAnalysis}`;
        await fetch(URL, {
            method: "POST",
            headers: {
                "Content-type": "application/json",
                Authorization: sessionStorage.getItem("my-token"),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                setHiddenExcel(true);
                //debugger;
                if (data !== 0 && data !== "0" && data !== undefined) {
                    setNewSuccessAlert(false);
                    setErrorMessage(detailsFileName + " is send to " + email + ". Please check after 30 minutes");
                    // setLoading(false);
                } else {
                    setNewErrorAlert(false);
                    setErrorMessage("Error!!");
                    // setLoading(false);
                }
            });
        // setLoading(false);
        // setHiddenExcel(true);
    };

    const DownloadExcelData = async () => {
        debugger;
        setSumExportLoading(true);
        setHiddenExcel(true);
        const URL = `${configData.BASE_APP_URL}FreightBill/GenerateExcelSheetResponseForManuallyTouchedBills`;
        console.log(URL);
        // let filename = summaryFileName;
        const response = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('my-token')
            },
            body: JSON.stringify({ data: manuallyTouchedBills }),
            responseType: 'blob'
        });
        // response.headers.forEach(function (val, key) {
        //     if (key === 'content-disposition') {
        //         // debugger;
        //         filename = val.split('filename=')[1].split('filename*=')[0].split(';')[0];
        //     }
        // });
        const data = await response.blob();
        const link = document.createElement('a');

        link.href = window.URL.createObjectURL(data);
        link.download = summaryFileName;
        link.click();
        setSumExportLoading(false);
    };

    const OpenDownloadPopUp = async () => {
        // const confirmed = window.confirm('Are you sure you want to export the data?');
        // if (!confirmed) {
        //     return;
        // }
        debugger;
        if (manuallyTouchedBills.length > 0) {
            if (isHidden == true) {
                setHiddenExcel(true);
                DownloadExcelData();
            }
            else {
                setHiddenExcel(false);
            }
        }
    };


    const [sizePerPage, setSizePerPage] = useState('50');

    const LoadDetailData = async (title, category, processStatusCode, customerKey, divisionKey, regionKey, branchKey, entryFrom, entryTo, shipDateFrom, shipDateTo, reportName, setLoadingFunc, flag) => {
        debugger;

        setLoadingFunc(true);
        setDetailData([]);
        const fbNumber = fbNum === "" ? "-1" : fbNum;
        const acctNumber = acctNo === "" ? "-1" : acctNo;
        const processCode = processStatusCode === "" ? "-1" : processStatusCode;

        const URL = `${configData.BASE_APP_URL}FreightBill/GetF068Details/${title}/${category}/${processCode}/${customerKey}/${divisionKey}/${regionKey}/${branchKey}/${entryFrom}/${entryTo}/${shipDateFrom}/${shipDateTo}/${reportName}`;
        let encoded = encodeURI(URL);

        try {
            const response = await fetch(encoded, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            if (response.ok) {
                const data = await response.json();

                // Modify the response by formatting 'billedAmount' and 'paidAmount'
                const modifiedResponse = data.map(item => ({
                    ...item,
                    billedAmount: formatAmountWithComma(item.billedAmount),
                    paidAmount: formatAmountWithComma(item.paidAmount),
                    // Add more properties as needed
                }));

                setDetailData(modifiedResponse);
                // OpenPopup();
                setHidden(false);
            } else {
                console.error(`Error fetching data: ${response.statusText}`);
            }
        } catch (error) {
            console.error('Error during fetch:', error);
        } finally {
            setLoadingFunc(false);
        }

        const tempColumnsDetail = [];
        let freightBillKeyCol = null;
        Object.keys(detailManuallyTouchedRef.current[0]).map((col) => {
            // debugger;
            const newCol = {};
            if (col === "carrierName") {
                newCol.dataField = col;
                newCol.text = "Transportation Provider Name";
                newCol.headerStyle = { width: '280px', textAlign: 'center' };
                newCol.align = 'left';
                newCol.sort = true;
                newCol.csvFormatter = freightBillFormattercsv
                newCol.filter = customFilter();
                newCol.filterRenderer = (onFilter, column) =>
                    <ColumnFilter onFilter={onFilter} column={column} />
                tempColumnsDetail.push(newCol);
            }
            else if (col === "proNumber") {
                newCol.dataField = col;
                newCol.text = "Freight Bill/Package Number";
                newCol.headerStyle = { width: '180px', textAlign: 'center' };
                newCol.align = 'left';
                newCol.sort = true;
                newCol.csvFormatter = invoicenumberFormattercsv;
                newCol.filter = customFilter();
                newCol.filterRenderer = (onFilter, column) =>
                    <ColumnFilter onFilter={onFilter} column={column} />
                tempColumnsDetail.push(newCol);
            }
            else if (col === "invoiceNumber") {
                newCol.dataField = col;
                newCol.text = "Invoice Number";
                newCol.headerStyle = { width: '180px', textAlign: 'center' };
                newCol.align = 'left';
                newCol.sort = true;
                newCol.csvFormatter = accountnumberFormattercsv;
                newCol.filter = customFilter();
                newCol.filterRenderer = (onFilter, column) =>
                    <ColumnFilter onFilter={onFilter} column={column} />
                tempColumnsDetail.push(newCol);
            }
            else if (col === "billedAmount") {
                newCol.dataField = col;
                newCol.text = "Billed Amount";
                newCol.headerStyle = { width: '152px', textAlign: 'center' };
                newCol.align = 'right';
                newCol.sort = true;
                // newCol.formatter = AmountFormatter;
                // newCol.csvFormatter = AmountFormatterCsv;
                newCol.filter = customFilter();
                newCol.filterRenderer = (onFilter, column) =>
                    <ColumnFilter onFilter={onFilter} column={column} />
                tempColumnsDetail.push(newCol);
            }
            else if (col === "paidAmount") {
                newCol.dataField = col;
                newCol.text = "Paid Amount";
                newCol.headerStyle = { width: '92px', textAlign: 'center' };
                newCol.align = 'right';
                newCol.sort = true;
                // newCol.formatter = AmountFormatter;
                // newCol.csvFormatter = AmountFormatterCsv;
                newCol.filter = customFilter();
                newCol.filterRenderer = (onFilter, column) =>
                    <ColumnFilter onFilter={onFilter} column={column} />
                tempColumnsDetail.push(newCol);
            }
            else if (col === "freightBillKey") {
                newCol.dataField = col;
                newCol.text = "Freight Bill Key";
                newCol.headerStyle = { width: '150px', textAlign: 'center' };
                newCol.align = 'left';
                newCol.sort = true;
                newCol.csvFormatter = freightBillFormattercsv
                newCol.filter = customFilter();
                newCol.filterRenderer = (onFilter, column) =>
                    <ColumnFilter onFilter={onFilter} column={column} />

                tempColumnsDetail.push(newCol);
                freightBillKeyCol = newCol
            }
            else if (col === "columnName") {
                // debugger;
                newCol.dataField = col;
                newCol.headerStyle = { width: '180px', textAlign: 'center' };
                newCol.align = 'center';
                newCol.sort = true;
                newCol.csvFormatter = freightBillFormattercsv
                newCol.filter = customFilter();
                newCol.filterRenderer = (onFilter, column) =>
                    <ColumnFilter onFilter={onFilter} column={column} />

            }
            else if (col === "itemCount") {
                // debugger;
                if (detailManuallyTouchedRef.current[0].columnName !== null) {
                    newCol.dataField = col;
                    newCol.text = detailManuallyTouchedRef.current[0].columnName;
                    newCol.headerStyle = { width: '180px', textAlign: 'center' };
                    newCol.align = 'right';
                    newCol.sort = true;
                    newCol.csvFormatter = freightBillFormattercsv
                    newCol.filter = customFilter();
                    newCol.filterRenderer = (onFilter, column) =>
                        <ColumnFilter onFilter={onFilter} column={column} />

                    tempColumnsDetail.push(newCol);
                }

            }


            // if (col !== 'columnName' && col !== "itemCount") {
            //     tempColumnsDetail.push(newCol);
            // }


        })
        // console.log(tempColumnsDetail);
        if (category !== "Shipment Count for Shipment Visibility (Customer Level Only)") {
            setColumnsDetail(tempColumnsDetail);
        }
    }

    const columnFormatter = (cell, row, rowIndex, formatExtraData) => {
        if (row.rowType == 'H') {
            return (
                <div>
                    <span className='font-weight-bold'><b>{row.title}</b></span>
                </div>
            )
        }
        else if (row.rowType == 'D') {
            return (
                <div>
                    <span><a href='#'><i className="fa fa-expand mr-1"></i></a>{row.category}</span>
                </div>
            )
        }
        else if (row.rowType == 'S') {
            return (
                <div>
                    <span className='text-end'>{row.title}</span>
                </div>
            )
        }
    }

    const columnFormatterCsv = (cell, row, rowIndex, formatExtraData) => {
        if (row.rowType == 'H') {
            return (
                row.title
            )
        }
        else if (row.rowType == 'D') {
            return (
                row.category
            )
        }
        else if (row.rowType == 'S') {
            return (
                row.title
            )
        }
    }

    const amtFormatter = (cell, row, rowIndex, formatExtraData) => {
        if (row.rowType == 'S') {
            return (
                <div>
                    <span className='font-weight-bold'><b>{cell.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</b></span>
                </div>
            )
        }
        else {
            return (
                <div>
                    <span className='font-weight-bold'>{cell.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                </div>
            )
        }
        // else
        // {
        //     return (
        //         <div>
        //             <span><a href='#'><i className="fa fa-expand mr-1"></i></a>{row.category}</span>
        //         </div>
        //     )
        // }
    }


    const IsManualFormatter = (cell) => {
        return (
            cell == 'Y' ? <span>Yes</span> : <span>No</span>
        )
    }

    const AmountFormatter = (cell) => {
        return (
            <span>{parseFloat(cell).toFixed(2)}</span>
        )
    }

    const AmountFormatterCsv = (cell) => {
        // console.log(cell);
        const formattedDecimal = (cell !== undefined && cell !== 0 ? cell.toFixed(2) : "0.00");
        return (
            `${formattedDecimal}`
        )
    }




    let onCustomerFilter;
    let onCarrierFilter;

    const onCustomerChangeFilter = (customerKey, divisonKey, regionKey, branchKey, startDate, endDate, startShipDate, endShipDate, reportName, excludeRateAndRouteAnalysis) => {
        //debugger;
        // onCustomerFilter(val);

        setDetailLevel('Division');
        setIsHidden(false);

        if (divisonKey > 0) {
            setDetailLevel('Region');
        }

        if (regionKey > 0) {
            setDetailLevel('Branch');
        }

        if (branchKey > 0) {
            setIsHidden(true);
        }

        setFromDate(startDate);
        setToDate(endDate);
        setSelectedCustKey(customerKey);
        setSelectedDivisionKey(divisonKey);
        setSelectedRegionKey(regionKey);
        setSelectedBranchKey(branchKey);
        setFromDate(startDate);
        setToDate(endDate);
        setFromShipDate(startShipDate);
        setToShipDate(endShipDate);
        setSelectedReportName(reportName);
        setSelectedExcludeRateAndRouteAnalysis(excludeRateAndRouteAnalysis);
        LoadSummaryData(customerKey, divisonKey, regionKey, branchKey, startDate, endDate, startShipDate, endShipDate, reportName, excludeRateAndRouteAnalysis);
    };
    const onCarrierChangeFilter = (val) => {
        //onCarrierFilter(val);
        // console.log(val)
    };

    const columns = [
        {
            dataField: 'rowID',
            text: 'Id',
            headerStyle: { width: '50' },
            hidden: true,
            csvExport: false,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'title',
            text: 'Title',
            headerStyle: { width: '50' },
            hidden: true,
            csvExport: false,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'category',
            text: 'Category',
            headerStyle: { width: '50' },
            hidden: true,
            csvExport: false,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'processStatusCode',
            text: 'Processed Status Code',
            headerStyle: { width: '50' },
            hidden: true,
            csvExport: false,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'category',
            // text: 'All Shipped Dates',
            // text: (
            //     <div>
            //         <div>Owner: {ownerName}</div>
            //         <div>Customer: {customerName}</div>
            //         <div>Division: {divisionName}</div>
            //         <div>Region: {regionName}</div>
            //         <div>Branch: {branchName}</div>
            //         <div>{fromtoDate}</div>
            //         <div>All Shipped Dates</div>
            //     </div>
            // ),

            headerStyle: { width: '300px', textAlign: 'left' },
            formatter: columnFormatter,
            csvFormatter: columnFormatterCsv,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    if (loading) {
                        return
                    }
                    setDetailData([]);
                    setPage(1);
                    const selectedRow = {
                        rowId: row.rowID,
                        title: row.title,
                        category: row.category,
                        processStatusCode: row.processStatusCode,
                        total: row.total

                    }
                    if (row.rowType === 'D') {
                        if (row.category === "Shipment Count for Shipment Visibility (Customer Level Only)") {
                            setColumnsDetail([{
                                dataField: 'carrierName',
                                text: 'Transportation Provider Name',
                                headerStyle: { width: '200px', textAlign: 'center' },
                                align: 'left',
                                sort: true,
                                csvFormatter: freightBillFormattercsv,
                                filter: customFilter(),
                                filterRenderer: (onFilter, column) =>
                                    <ColumnFilter onFilter={onFilter} column={column} />

                            },
                            {
                                dataField: 'proNumber',
                                text: 'Freight Bill/Package Number',
                                headerStyle: { width: '120px', textAlign: 'center' },
                                align: 'left',
                                sort: true,
                                csvFormatter: invoicenumberFormattercsv,
                                filter: customFilter(),
                                filterRenderer: (onFilter, column) =>
                                    <ColumnFilter onFilter={onFilter} column={column} />
                            },
                            {
                                dataField: 'entryDate',
                                text: 'Entry Date',
                                headerStyle: { width: '120px', textAlign: 'center' },
                                align: 'left',
                                sort: true,
                                csvFormatter: entryDateFormattercsv,
                                filter: customFilter(),
                                formatter: entryDateFormatter,
                                filterRenderer: (onFilter, column) =>
                                    <ColumnFilter onFilter={onFilter} column={column} />
                            },
                            {
                                dataField: 'pickupDate',
                                text: 'Ship Date',
                                headerStyle: { width: '120px', textAlign: 'center' },
                                align: 'left',
                                sort: true,
                                csvFormatter: invoiceDateFormattercsv,
                                formatter: invoiceDateFormatter,
                                filter: customFilter(),
                                filterRenderer: (onFilter, column) =>
                                    <ColumnFilter onFilter={onFilter} column={column} />
                            },
                            ]);
                        }
                        setSelectedRow(selectedRow);
                        debugger;
                        LoadDetailData(row.title, row.category, row.processStatusCode, selectedCustKey, selectedDivisionKey, selectedRegionKey, selectedBranchKey, fromDate, toDate, fromShipDate, toShipDate, selectedReportName, setLoading, false);
                    }
                }
            },
            filter: customFilter(),
            filterRenderer: (onFilter, column) => {
                onCustomerFilter = onFilter;
                <ColumnFilter onFilter={onFilter} column={column} />
            }
        },
        {
            dataField: 'edi',
            text: 'EDI',
            headerStyle: { width: '75px', textAlign: 'center' },
            formatter: amtFormatter,
            align: "right",
            // csvFormatter: amtFormatterCsv,
            // filter: customFilter(),
            // sort: true,
            // filterRenderer: (onFilter, column) => {
            //     onCarrierFilter = onFilter;
            //     <ColumnFilter onFilter={onFilter} column={column} />
            // }
            // filterRenderer: (onFilter, column) =>
            //     <ColumnFilter onFilter={onFilter} column={column} />


        },
        {
            dataField: 'manual',
            text: 'Manual',
            headerStyle: { width: '75px', textAlign: 'center' },
            // filter: customFilter(),
            formatter: amtFormatter,
            align: "right",
            // csvFormatter: amtFormatterCsv,
            // sort: true,
            // filterRenderer: (onFilter, column) =>
            //     <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'web',
            text: 'Web',
            headerStyle: { width: '75px', textAlign: 'center' },
            hidden: false,
            // filter: customFilter(),
            formatter: amtFormatter,
            align: "right",
            // csvFormatter: amtFormatterCsv,
            // sort: true,
            // filterRenderer: (onFilter, column) =>
            //     <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'total',
            text: 'Total',
            headerStyle: { width: '75px', textAlign: 'center' },
            // filter: customFilter(),
            align: "right",
            formatter: amtFormatter
            // filterRenderer: (onFilter, column) =>
            //     <ColumnFilter onFilter={onFilter} column={column} />

        }
    ];

    function rowClasses(row, rowIndex) {
        // debugger;
        if (row.rowID === selectedSummaryRow.rowId) {
            if (hidden !== true) {
                return 'selected-row'
            }
            else {
                return ''
            }
        }

    }


    const observer = useRef(
        new IntersectionObserver((entries, pagingOptioins) => {
            const first = entries[0];
            if (first.isIntersecting) {
                setPage((no) => no + 1);
            }
        })
    );

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    // useEffect(() => {
    //     if (selectedSummaryRow.customerKey) {
    //         LoadDetailData(selectedSummaryRow.customerKey, selectedSummaryRow.carrierKey, selectedSummaryRow.billType, selectedSummaryRow.statusCode, setFBLoading, true)
    //     }
    // }, [pageRef.current])

    // useEffect(() => {
    //     const currentElement = lastElement;
    //     const currentObserver = observer.current;

    //     if (currentElement) {
    //         currentObserver.observe(currentElement);
    //     }

    //     return () => {
    //         if (currentElement) {
    //             currentObserver.unobserve(currentElement);
    //         }
    //     };
    // }, [lastElement]);



    const sizePerPageRenderer = ({
        options,
        currSizePerPage,
        onSizePerPageChange
    }) => (
        <div className="btn-group" role="group">
            {
                options.map((option) => {
                    const isSelect = currSizePerPage === `${option.page}`;
                    return (
                        <button
                            key={option.text}
                            type="button"
                            onClick={() => onSizePerPageChange(option.page)}
                            className={`btn ${isSelect ? 'btn-secondary' : 'btn-warning'}`}
                        >
                            {option.text}
                        </button>
                    );
                })
            }
        </div>
    );

    // const options = {
    //     sizePerPageRenderer,
    //     sizePerPageList: [{
    //         text: '50', value: 50
    //     }, {
    //         text: '100', value: 100
    //     },
    //     {
    //         text: '200', value: 200
    //     }, {
    //         text: 'All', value: manuallyTouchedBills.length
    //     }]
    // };


    const detailOptions = {
        sizePerPageRenderer,
        sizePerPageList: [
            {
                text: '50', value: 50
            }, {
                text: '100', value: 100
            },
            {
                text: '200', value: 200
            },
            {
                text: 'All', value: detailManuallyTouchedBills.length
            }
        ]


    };

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.id);
    }

    const DownloadDetailData = async () => {
        debugger;
        setExportLoading(true);
        const URL = selectedSummaryRow.category === "Shipment Count for Shipment Visibility (Customer Level Only)" ? `${configData.BASE_APP_URL}FreightBill/GenerateExcelForShipmentVisibility` : `${configData.BASE_APP_URL}FreightBill/GenerateExcelForManuallyTouchedBillsDetail`;
        // console.log(URL);

        const modifiedResponse = detailManuallyTouchedRef.current.map(item => ({
            ...item,
            billedAmount: removeCommafromNumber(item.billedAmount),
            paidAmount: removeCommafromNumber(item.paidAmount),
            // Add more properties as needed
        }));


        const response = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('my-token')
            },
            body: JSON.stringify({ data: modifiedResponse }),
            responseType: 'blob'
        });

        const data = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = `F068 Detail.xlsx`;
        link.click();
        setExportLoading(false);
    };

    const Loader = () => {
        return (
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        )
    }

    const breadcumTitle = <div dangerouslySetInnerHTML={{ __html: 'Manually Touched Bills <span class="breadcumspan">(F068 Report)</span>' }} />;
    console.log(columnsDetail, 'columnsDetail')
    return (
        <>
            <div className='st1'>
                <LeftMenu />
                <div className="mcw">
                    <TopBar />
                    <div className='pt-1 px-3 pb-3 py-3'>
                        <div className='floating-table-overlay' hidden={hidden}></div>
                        <div hidden={hidden} className="floating-table shadow-sm full-height-modal">
                            <div className='row g-0 p-2 bg-white'>
                                <button onClick={() => setHidden(!hidden)} className='close-modal'><i className="fas fa-times"></i></button>
                                <GridDataManuallyTouchedBills data={customerName} data2={selectedRowRef.current} />
                            </div>
                            <div className='border-top p-2 table-container'>
                                <div className='custom-table-text manual-table-text'>
                                    {detailManuallyTouchedBills.length > 0 ?
                                        <ToolkitProvider
                                            keyField="freightBillKey"
                                            data={detailManuallyTouchedBills}
                                            columns={columnsDetail}
                                            exportCSV={{ fileName: 'Manually Touched Bills Detail.csv' }}>
                                            {
                                                props => (
                                                    <div>
                                                        {/* <div className='sticky-sm-top'> */}

                                                        {/* </div> */}
                                                        <BootstrapTable
                                                            classes='table table-striped table-hover table-width-small'
                                                            headerClasses='table-top'
                                                            bootstrap4
                                                            pagination={paginationFactory(detailOptions)}
                                                            keyField='freightBillKey'
                                                            data={detailManuallyTouchedRef.current}
                                                            {...props.baseProps}
                                                            filter={filterFactory()}
                                                        />
                                                        <button className='btn react-bs-table-csv-btn' onClick={DownloadDetailData}><i className='fa fa-download'></i> Export
                                                            {'  '} {exportLoading && <Loader />} {'  '}
                                                        </button>
                                                        {/* <ExportCSVButton {...props.csvProps}><i className='fa fa-download' style={{ marginTop: '50px' }}></i>Export</ExportCSVButton> */}

                                                    </div>
                                                )
                                            }
                                        </ToolkitProvider> : <>
                                            <MycustomDesignGrid column={columnsDetail} />
                                        </>}
                                    <div ref={setLastElement} style={{ minHeight: "10px", margin: "20px" }}>
                                        {/* <span style={{ display: fbLoading ? "block" : "none" }}>Loading...</span> */}
                                        {fbLoading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : fbLoading}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div hidden={newErrorAlert}>
                            <SweetAlert danger title="Error" onConfirm={onConfirmFunc}>
                                {errorMessage}
                            </SweetAlert>
                        </div>
                        <div hidden={newSuccessAlert}>
                            <SweetAlert style={{ marginTop: '400px' }} success title="" onConfirm={onConfirmFunc}>
                                {errorMessage}
                            </SweetAlert>
                        </div>

                        {/* for Excel pop up start */}
                        <div className='floating-table-overlay' hidden={hiddenExcel}></div>
                        <div hidden={hiddenExcel} className="floating-table shadow-sm full-height-modal excel-modal">
                            <div className='row g-0 p-2 bg-white'>
                                <button onClick={() => setHiddenExcel(!hiddenExcel)} className='close-modal'><i className="fas fa-times"></i></button>                            </div>
                            <div className='row border-top p-2'>
                                <div className='col-12 text-center'>
                                    <b>Select the excel data format:</b>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-3'></div>
                                <div className='col-3'>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="downloadExcel" id="defaultExcel" checked={selectedOption === 'defaultExcel'} onChange={handleOptionChange} />
                                        <label className="form-check-label" for="defaultExcel">
                                            Summary (Download)
                                        </label>
                                    </div>
                                </div>
                                <div className='col-5' hidden={isHidden}>
                                    <div class="form-check">
                                        <input className="form-check-input" type="radio" name="downloadExcel" id="detailExcel" checked={selectedOption === 'detailExcel'} onChange={handleOptionChange} />
                                        <label className="form-check-label" for="detailExcel">
                                            Summary with Details (Send in my email)
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className='row border-top p-4'>
                                <div className='col-12 text-center'>

                                    <button type='button' className='btn btn-filter' onClick={SelectDownloadOptions}>Ok</button>
                                    <button type='button' className='btn btn-clear ms-2' onClick={() => setHiddenExcel(!hiddenExcel)}>Cancel</button>
                                </div>
                            </div>

                        </div>
                        {/* for Excel pop up end */}

                        {/* <Breadcrumbs title="Invoice Status (Freight Bill Status Report)" /> */}
                        <Breadcrumbs title={breadcumTitle} />
                        {loading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : loading}
                        {/* <div className='sticky-top-content'>
                            <TopFilterManuallyTouchedBills oncustom={onCustomerChangeFilter} oncustom1={onCarrierChangeFilter} criData={criData} />
                        </div > */}
                        <div>Owner: {ownerName} | Customer: {customerName} | Division: {divisionName} | Region: {regionName} | Branch: {branchName} | {fromtoDate} | All Shipped Dates</div>
                        <div className='d-flex'>
                            <div className="table-container">
                                <div className='grid-toggle'>
                                    <div className='manualmain-table-text main-table-text dropup'>
                                        <div style={{ backgroundColor: '#fff', marginTop: '5px', textAlign: "right" }}>
                                            <button className='btn react-bs-table-csv-btn' onClick={OpenDownloadPopUp}>
                                                {'  '} {sumExportLoading && <Loader />} {'  '}
                                                <i className='fa fa-download'></i> Export
                                            </button>
                                        </div>
                                        <ToolkitProvider
                                            keyField="rowID"
                                            data={manuallyTouchedBills}
                                            columns={columns}
                                            // rowClasses={ rowClasses }
                                            exportCSV={{
                                                fileName: 'F068_' + customerShortName + '_' + toExportDate + '.csv'
                                            }}>
                                            {
                                                props => (
                                                    <div>
                                                        {/* <div className='font-weight-bold'><label>Customer:</label> <span>{customerName}</span></div>
                                                        <div className='font-weight-bold'><label>{fromtoDate}</label></div> */}
                                                        <BootstrapTable
                                                            classes='table table-striped table-hover table-width'
                                                            headerClasses='table-top'
                                                            bootstrap4
                                                            rowClasses={rowClasses}
                                                            // pagination={paginationFactory(options)}
                                                            {...props.baseProps}
                                                            filter={filterFactory()}
                                                        />
                                                        {/* <button className='btn react-bs-table-csv-btn' onClick={DownloadSummaryData}><i className='fa fa-download'></i> Export</button> */}
                                                        {/* <ExportCSVButton {...props.csvProps}><i className='fa fa-download'></i> Export</ExportCSVButton> */}
                                                    </div>
                                                )
                                            }
                                        </ToolkitProvider>
                                    </div>
                                    {/* <div style={{ backgroundColor: '#fff', marginTop: '5px' }}><button className='btn react-bs-table-csv-btn' onClick={OpenDownloadPopUp}><i className='fa fa-download'></i> Export</button></div> */}
                                </div>
                            </div>
                            <F68RightFilterToggle onSearchClick={searchOnClick} />
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}